import { PropsWithChildren, useEffect, useState } from "react";
import { DeveloperContext } from "../context/DeveloperContext";
import { SESSION_STORAGE_KEY } from "../common/const";
import { useLocation, useNavigate } from "react-router-dom";
import { DEVELOPER_URLS } from "../common/data";

export const DeveloperProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [userID, setUserID] = useState<number>(0);
  const [username, setUserName] = useState<string>("");
  const [userEmail, setUserEmail] = useState<string>("");
  const [sessionKey, setSessionKey] = useState<string>();

  useEffect(() => {
    const userID = sessionStorage.getItem(SESSION_STORAGE_KEY.USER_ID);

    if (!userID) {
      setUserID(0);
    } else {
      setUserID(parseInt(userID));
    }

    const username = sessionStorage.getItem(SESSION_STORAGE_KEY.USERNAME);

    if (!username) {
      setUserName("");
    } else {
      setUserName(username);
    }

    const userEmail = sessionStorage.getItem(SESSION_STORAGE_KEY.USER_EMAIL);

    if (!userEmail) {
      setUserEmail("");
    } else {
      setUserEmail(userEmail);
    }

    const sessionKey = sessionStorage.getItem(SESSION_STORAGE_KEY.SESSION_KEY);

    if (!sessionKey) {
      setSessionKey("");
    } else {
      setSessionKey(sessionKey);
    }
  }, []);

  useEffect(() => {
    if (sessionKey === "") {
      const path = location.pathname;

      for (let i = 0; i < DEVELOPER_URLS.length; i++) {
        if (path === DEVELOPER_URLS[i]) {
          navigate("/login");
          return;
        }
      }
    }
  }, [sessionKey]);

  const handleSessionKey = (key?: string) => {
    setSessionKey(key);
    if (key === undefined) {
      sessionStorage.removeItem(SESSION_STORAGE_KEY.SESSION_KEY);
    } else {
      sessionStorage.setItem(SESSION_STORAGE_KEY.SESSION_KEY, key);
    }
  };

  const handleUsername = (name: string) => {
    setUserName(name);
    sessionStorage.setItem(SESSION_STORAGE_KEY.USERNAME, name);
  };

  const handleUserEmail = (email: string) => {
    setUserEmail(email);
    sessionStorage.setItem(SESSION_STORAGE_KEY.USER_EMAIL, email);
  };

  const handleUserID = (id: number) => {
    setUserID(id);
    sessionStorage.setItem(SESSION_STORAGE_KEY.USER_ID, id.toString());
  };

  return (
    <DeveloperContext.Provider
      value={{
        userID,
        username,
        userEmail,
        sessionKey,
        handleUserID,
        handleSessionKey,
        handleUsername,
        handleUserEmail,
      }}
    >
      {children}
    </DeveloperContext.Provider>
  );
};
